import { Skeleton } from '@/components/ui/skeleton';
import { ConnectorRowSkeleton } from '@/components/tenants/home/connector-row-skeleton';

/**
 * Loading placeholder for ConnectorsTable — a search/add toolbar plus a grid of
 * connector-row skeletons matching the live grid breakpoints, so the table
 * settles into content without a spinner or layout shift.
 */
export function ConnectorsTableSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <Skeleton className="h-9 w-full sm:max-w-md" />
        <Skeleton className="h-9 w-36" />
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <ConnectorRowSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}
